import { render, staticRenderFns } from "./MessageNotice.vue?vue&type=template&id=5efa7372&scoped=true&"
import script from "./MessageNotice.vue?vue&type=script&lang=js&"
export * from "./MessageNotice.vue?vue&type=script&lang=js&"
import style0 from "./MessageNotice.vue?vue&type=style&index=0&id=5efa7372&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efa7372",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5efa7372')) {
      api.createRecord('5efa7372', component.options)
    } else {
      api.reload('5efa7372', component.options)
    }
    module.hot.accept("./MessageNotice.vue?vue&type=template&id=5efa7372&scoped=true&", function () {
      api.rerender('5efa7372', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MessageAgentSub/MessageNotice.vue"
export default component.exports